<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>

<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

<ng-container *ngIf="!isLoading">
  <code-area [isString]="true" [parent]="this.boundJson" [readOnly]="true" [value]="this.boundJson.data" key="code"
                 type="json"></code-area>
</ng-container>

